<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="发送就餐提醒"
      @ok="handleSubmit"
    >
      <span style="margin-left:30px;">就餐提醒信息</span>
      <a-form
        class="custom-compact-form"
        style="margin-top:15px;"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="提醒内容">
          <a-textarea
            v-decorator="['content', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入提醒内容' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="就餐地点">
          <a-textarea
            v-decorator="['location', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入就餐地点' },
                { max: 100, message: '最多100个字符' },
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="开始时间">
          <a-date-picker
            style="width: 100%;"
            format="YYYY-MM-DD HH:mm"
            @openChange="handleStartOpenChange"
            :show-time="{ format: 'HH:mm' }"
            v-decorator="['start_at', {
              rules: [
                { required: true, message: `请选择开始时间` }
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="结束时间">
          <a-date-picker
            style="width: 100%;"
            @openChange="handleEndOpenChange"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH:mm' }"
            v-decorator="['end_at', {
              rules: [
                { required: true, message: `请选择结束时间` }
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

import { sendMealNotice } from '@/api/order'
import {formatDateTimeMin, formatMinuteTime} from '@/utils/time'

export default {
  name: 'SendMealNotice',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    },
    hallName: {
      type: String,
      required: true
    },
    deathName: {
      type: String,
      required: true
    },
    beginTime: {
      type: String,
      required: true
    },
    endTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'send_meal_notice' }),
      submitting: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    handleStartOpenChange() {
      const fieldsValue = this.form.getFieldsValue()
      const startValue = fieldsValue.start_at
      const endValue = fieldsValue.end_at
      if (endValue && startValue) {
        if (endValue.valueOf() < startValue.valueOf()) {
          this.endOpen = false
          this.$warning({
            title: '结束时间不能小于开始时间',
            content: ''
          })
          this.form.setFieldsValue({ start_at: null })
        }
      }
    },
    handleEndOpenChange() {
      const fieldsValue = this.form.getFieldsValue()
      const startValue = fieldsValue.start_at
      const endValue = fieldsValue.end_at
      if (endValue && startValue) {
        if (endValue.valueOf() < startValue.valueOf()) {
          this.endOpen = false
          this.$warning({
            title: '结束时间不能小于开始时间',
            content: ''
          })
          this.form.setFieldsValue({ end_at: null })
        }
      }
    },
    fetchFormData() {
      // const startDate = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm')
      this.$nextTick(() => {
        this.form.setFieldsValue({
          content: this.hallName + '(逝者姓名：' + this.deathName + ')，请丧属与亲朋好友准备就餐。',
          start_at: this.beginTime,
          end_at: this.endTime
        })
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const fieldsValue = this.form.getFieldsValue()
          const startValue = fieldsValue.start_at
          const endValue = fieldsValue.end_at
          if (startValue.valueOf() > endValue.valueOf()) {
            this.$message.error('结束时间不能大于开始时间')
            this.submitting = false
            return
          }
          const values = {
            ...fieldsValue,
            begin_time: formatMinuteTime(fieldsValue.start_at),
            end_time: formatMinuteTime(fieldsValue.end_at)
          }
          sendMealNotice(this.serviceOrderId, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
